import React from 'react';
import moment from 'moment';

import ArtifactContent from '../ArtifactContent';
import StackedCard from '../../../../components/StackedCard';
import ExternalLinksContent from '../ExternalLinksContent';

import { Release } from "../../../../types/service"

import './index.scss';

interface ServiceReleaseCardProps {
  release: Release
  git_url: string;
}

const ServiceReleaseCard: React.FunctionComponent<ServiceReleaseCardProps> = ({release, git_url}) => {
  
  const buildGitHubLink = () => {
    const githubRepo = git_url.split(':')[1].split('.')[0];
    return `https://github.com/${githubRepo}/commit/${release.git_sha}`
  }

  const formatDate = () => {
    const newDate = moment(release.build_time);
    return`${newDate.format("MMM DD")} at ${newDate.format("h:mma")}`
  }

  return (
    <div className="service-details-card">
      <StackedCard header={"Release"}>
        {formatDate()}
      </StackedCard>
      {
        <StackedCard header={"Artifacts"}>
          {
            release.artifacts && release.artifacts.length ?
            release.artifacts.map(artifact => {
              return <ArtifactContent artifact={artifact} key={artifact.version_string}/>
            }) :
            <p className="no-artifacts">No artifacts available</p>
          }
        </StackedCard>
      }
      <StackedCard header={"External Links"}>
        <ExternalLinksContent buildkiteUrl={release.build_url} gitHubUrl={buildGitHubLink()} />
      </StackedCard>
    </div>
  )
}

export default ServiceReleaseCard;